<template>
  <div v-if="api_data.Farmer">
    <div class="image-input image-input-outline" :id="file_input_name">
      <div class="image-input-wrapper"
           :style="{ backgroundImage: `url('${file_url}')` }"></div>
      <label
          class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
          data-action="change" data-toggle="tooltip" title=""
          data-original-title="Change File">
        <i class="fa fa-pen icon-sm text-muted"></i>
        <input type="file" v-on:change="setFileToBinding"
               :name="file_input_name" accept=".png, .jpg, .jpeg"/>
      </label>
      <span class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
            data-action="cancel" data-toggle="tooltip" title="Cancel avatar">
                                    <i class="ki ki-bold-close icon-xs text-muted"></i>
                                </span>
    </div>
    <span v-if="file_validation_message" class="form-text">{{ file_validation_message }}</span>
    <div class="row" v-if="file_url">
      <div class="col-md-2">
        <a :href="file_url" target="_blank"><i class="fa fa-search-plus" aria-hidden="true"></i></a>
      </div>
      <div class="col-md-6">
        1MB Size
        <a :href="file_url" download><i class="fa fa-download" aria-hidden="true"></i></a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'file-to-object',
  props: {
    api_data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    file_url: {
      type: String,
      default: function () {
        return ''
      },
    },
    file_input_name: {
      type: String,
      default: function () {
        return ''
      },
    },
  },
  data: () => ({
    file_validation_message: ''
  }),
  mounted() {
    this.$nextTick(function () {
      new KTImageInput(this.$props.file_input_name);
    })
  },
  methods: {
    async setFileToBinding(e) {
      var oldPhoto = this.$props.file_url;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      var file = files[0];
      var file_size = file.size / 1024 / 1024;
      if (file_size > 1) {
        this.file_validation_message = 'Photo size can be 1mb only.';
        this.$props.api_data.Farmer[this.file_input_name] = oldPhoto;
        return;
      }
      var reader = new FileReader();
      var thiser = this;
      reader.onload = (e) => {
        thiser.api_data.Farmer[this.file_input_name] = e.target.result;
      };
      reader.readAsDataURL(file);
      this.file_validation_message = false;
    }
  }
}
</script>
